import { useTranslate } from 'hooks/useTranslate';
import { Modal } from 'react-bootstrap';
import { FC } from 'react';
import { useBeneficiarySellModal } from '../context/BeneficiarySellModalContext';

const BeneficiarySellModalHeader: FC = () => {
  const { t } = useTranslate();

  const { actions } = useBeneficiarySellModal();

  return (
    <>
      <Modal.Header>
        <h5 className="modal-title">{t('IncentiveValueSimulator')}</h5>
        <a className="close cursor-pointer" onClick={actions.handleCloseModal}>
          <em className="icon ni ni-cross" />
        </a>
      </Modal.Header>
    </>
  );
};

export default BeneficiarySellModalHeader;
